import AnimalTypeList from './animal-types.list';

export const AnimalTypeStores = {
    list: AnimalTypeList,
};
